import React from 'react';
import PropTypes from 'prop-types';

import ErrorModal from '../ErrorModal/ErrorModal';

import './StripeAddCardErrorModal.scss';
import { getTranslation } from '../../providers/TranslationProvider';

const StripeAddCardErrorModal = (props) => {
  const { message, onClose } = props;

  return (
    <ErrorModal
      onErrorModalClose={onClose}
      title={getTranslation({
        translationKey: 'this_card_could_not_be_added',
        fallback: 'This card could not be added.',
      })}
      message={message}
      primaryCTAKey="button_dismiss"
      primaryCTAText={getTranslation({
        translationKey: 'dismiss',
        fallback: 'Dismiss',
      })}
      primaryCTAOnClick={onClose}
      allowClickOutsideToDimiss
    />
  );
};

StripeAddCardErrorModal.propTypes = {
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

StripeAddCardErrorModal.displayName = 'StripeAddCardErrorModal';
export default StripeAddCardErrorModal;
